import * as types from "../../actions/actionTypes";

const ADD_MODAL_INITIAL_STATE = {
  show: false,
  AddComponent: null,
  modalIcon: {
    normal: "",
    svg: ""
  },
  selectMode: false,
  loading: false,
  data: null
};
const MANAGEMENT_TEAM_ITEMS_MODAL_INITIAL_STATE = {
  show: false,
  toolId: -1,
  teamId: -1
};
const initialState = {
  addModalInfo: ADD_MODAL_INITIAL_STATE,
  managementTeamItemsModalInfo: MANAGEMENT_TEAM_ITEMS_MODAL_INITIAL_STATE
};
const SubItemsShared = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PROJECT_SUB_ITEMS_ADD_MODAL_INFO:
      return {
        ...state,
        addModalInfo: { ...state.addModalInfo, ...action.info }
      };

    case types.CLOSE_PROJECT_SUB_ITEMS_ADD_MODAL:
      return {
        ...state,
        addModalInfo: ADD_MODAL_INITIAL_STATE
      };

    case types.SET_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL_INFO:
      return {
        ...state,
        managementTeamItemsModalInfo: {
          ...state.managementTeamItemsModalInfo,
          ...action.info
        }
      };
    case types.CLOSE_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL:
      return {
        ...state,
        managementTeamItemsModalInfo: MANAGEMENT_TEAM_ITEMS_MODAL_INITIAL_STATE
      };
    default:
      return state;
  }
};

export default SubItemsShared;
